import { FeaturePaywallDialog } from '@/components/common/feature-paywall/feature-paywall-dialog'
import { useFeaturePaywallStore } from '@/stores/feature-paywall'

/**
 * Global FeaturePaywallProvider component
 * Renders the FeaturePaywallDialog based on the global feature paywall store state
 * Should be rendered once at the root/app layout level
 */
export function FeaturePaywallProvider() {
  const isOpen = useFeaturePaywallStore((state) => state.isOpen)
  const feature = useFeaturePaywallStore((state) => state.feature)
  const minimumPlan = useFeaturePaywallStore((state) => state.minimumPlan)
  const source = useFeaturePaywallStore((state) => state.source)
  const hideFeaturePaywall = useFeaturePaywallStore(
    (state) => state.hideFeaturePaywall,
  )

  if (!feature) {
    return null
  }

  return (
    <FeaturePaywallDialog
      feature={feature}
      minimumPlan={minimumPlan}
      open={isOpen}
      onOpenChange={hideFeaturePaywall}
      source={source}
    />
  )
}
